<template>
	<div id="app">
		<!-- <router-view /> -->
		<keep-alive><router-view v-if="$route.meta.keepAlive" /></keep-alive>
		<router-view v-if="!$route.meta.keepAlive" />
	</div>
</template>
<script>
import routes from '@/router/routes';

export default {
	watch: {
		$route(newData) {
			this.handleRouter(newData);
		}
	},
	created() {
		this.handleRouter(this.$route);
	},
	methods: {
		handleRouter(newData) {
			let curRouter = {};
			routes.forEach((item) => {
				if (item.path == newData.path) {
					curRouter = item;
				}
			});
			document.title = curRouter.title || '';
		}
	}
};
</script>
<style lang="less">
* {
	margin: 0;
	padding: 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	outline-style: none;
	list-style: none;
}

html,
body {
	background-color: #ffffff !important;
}

textarea,
input {
	display: block;
	resize: none;
	outline: none;
	border: none;
	background-color: transparent;
	-webkit-appearance: none;
	appearance: none;
	border-radius: 0;
}

textarea::-webkit-input-placeholder,
input::-webkit-input-placeholder {
	color: #cbcbcb;
}

textarea::input-placeholder,
input::input-placeholder {
	color: #cbcbcb;
}

input:disabled,
textarea:disabled {
	-webkit-opacity: 1;
	opacity: 1;
}

input.placeholder_em::-webkit-input-placeholder {
	font-style: italic;
}

input.placeholder_em::input-placeholder {
	font-style: italic;
}

.wechat_scroll {
	width: 100%;
	height: 100vh;
}

.home {
	width: 828px;
	min-height: 100vh;
	background-color: #e4e1df;
	display: flex;
	position: relative;
	overflow: hidden;
	& > div {
		flex: 1;
	}
}

.notScroll {
	&::-webkit-scrollbar {
		display: none !important;
		width: 0 !important;
		height: 0 !important;
	}
	&::-webkit-scrollbar-track {
		-webkit-box-shadow: none;
		background-color: transparent;
		width: 0;
		height: 0;
		display: none !important;
	}
	&::-webkit-scrollbar-thumb {
		-webkit-box-shadow: none;
		background-color: transparent;
		display: none !important;
	}
	&::-webkit-scrollbar-button {
		background-color: transparent;
		display: none !important;
	}
	&::-webkit-scrollbar-corner {
		background: transparent;
		display: none !important;
	}
}

.clear {
	width: 100% !important;
	clear: both !important;
}

.empty {
	width: 100%;
	min-height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #000;
}

.vhtmlBox {
	p,
	/deep/ {
		min-height: 20px;
	}
	
	pre {
		display: none;
	}
	
	ul {
		li {
			list-style: disc;
			list-style-position: inside !important;
		}
	}
	
	ol {
		li {
			list-style: auto;
			list-style-position: inside !important;
		}
	}
	
	img {
		max-width: 100%;
	}
	
	video {
		border-radius: 10px;
		overflow: hidden;
		max-width: 100%;
		display: block;
	}
}

.videobox {
	video {
		display: block;
		width: 715px;
		height: 380px;
		background-color: transparent;
		object-fit: cover;
	}
}

#video_play {
	position: fixed;
	top: -999vh;
	left: -999vw;
	width: 828px;
	height: 100%;
	z-index: 99999;
	pointer-events: auto !important;
}

.van-empty__image {
	width: auto !important;
	height: auto !important;
}

.van-empty__description {
	margin-top: 22px;
}

.qcc-result-box {
	z-index: 99 !important;
	overflow: hidden;

	.qcc-result-source {
		opacity: 0.01;
		position: absolute;
		left: 0;
		bottom: -100px;
	}
}
</style>
